// 9fbef606107a605d69c0edbcd8029e5d

export const CHECKOUT_SHIPPING = 'checkout.shipping';
export const ShipmentStandard = 'shipment_001';
export const ShipmentExpress = 'shipment_express';
export const ShipmentRush = 'shipment_rush';
export const ShipmentStandardShipping = 'shipment_001_shipping';
export const ShipmentExpressShipping = 'shipment_express_shipping';
export const ShipmentRushShipping = 'shipment_rush_shipping';
export const ShipmentUSPS = 'shipment_usps';
export const ShipmentFree = 'shipment_free';
export const ShipmentShippingTxt = 'shipment_shipping_txt';
export const ShipmentEstimatedDelivery = 'shipment_estimated_delivery';
export const ShipmentRangeDelivery = 'shipment_range_delivery';

export default {
  global: {
    accessibility: {
      lbl_info_icon: 'Info icon',
    },
    addEditAddress: {
      lbl_change_shipping_address: 'Change Shipping Address',
    },
  },
  checkout: {
    pickup: {
      lbl_pickup_venmo_banner:
        'To complete your Venmo payment, we’ll need a little more information.',
    },
    shipping: {
      [ShipmentStandard]: 'Standard',
      [ShipmentExpress]: 'Express',
      [ShipmentRush]: 'Rush',
      [ShipmentStandardShipping]: 'Standard Shipping',
      [ShipmentExpressShipping]: 'Express Shipping',
      [ShipmentRushShipping]: 'Rush Shipping',
      [ShipmentUSPS]: 'USPS',
      [ShipmentFree]: 'FREE',
      [ShipmentShippingTxt]: ' Shipping',
      [ShipmentEstimatedDelivery]: 'Up to _maxNoOfDays_ business days',
      [ShipmentRangeDelivery]: '_minNoOfDays_ to _maxNoOfDays_ business days',
    },
  },
};
